"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28714],{

/***/ 28714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clustering_map; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/connectors/useHits.js + 4 modules
var useHits = __webpack_require__(45846);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-hooks/dist/es/components/Configure.js + 2 modules
var Configure = __webpack_require__(94333);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/google-maps-react-markers/dist/index.modern.js
var index_modern = __webpack_require__(78104);
// EXTERNAL MODULE: ./node_modules/url-params-method/src/index.js
var src = __webpack_require__(24778);
// EXTERNAL MODULE: ./node_modules/use-supercluster/dist/use-supercluster.esm.js + 7 modules
var use_supercluster_esm = __webpack_require__(18390);
// EXTERNAL MODULE: ./components/icons/light/x.svg
var x = __webpack_require__(38928);
;// CONCATENATED MODULE: ./components/atoms/cluster/Cluster.tsx

/**
 * Cluster
 */ const Cluster = (param)=>{
    let { className ="" , children , cluster , superCluster , lat , lng , mapRef , count  } = param;
    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "\n        flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full p-2.5 text-neutrals-0\n        ".concat(count > 10 ? "bg-gradient-radial from-primary-600 via-primary-500" : "bg-gradient-radial from-primary-500 via-primary-400", "\n        ").concat(className, "\n    "),
        onClick: ()=>{
            var ref, ref1;
            const expansionZoom = Math.min(superCluster.getClusterExpansionZoom(cluster.id), 20);
            mapRef === null || mapRef === void 0 ? void 0 : (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setZoom(expansionZoom);
            mapRef === null || mapRef === void 0 ? void 0 : (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.panTo({
                lat,
                lng
            });
        },
        children: children !== null && children !== void 0 ? children : count
    });
};
Cluster.displayName = "Cluster";

;// CONCATENATED MODULE: ./components/atoms/cluster/index.ts

/* harmony default export */ var atoms_cluster = (Cluster);

// EXTERNAL MODULE: ./components/atoms/marker/index.ts + 2 modules
var marker = __webpack_require__(39866);
// EXTERNAL MODULE: ./components/molecules/card-flat/index.ts + 1 modules
var card_flat = __webpack_require__(2353);
// EXTERNAL MODULE: ./lib/graphql/transformers/card.ts
var card = __webpack_require__(48193);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(79080);
// EXTERNAL MODULE: ./lib/utils/utils.ts
var utils = __webpack_require__(622);
// EXTERNAL MODULE: ./lib/utils/client/post.ts
var post = __webpack_require__(45618);
;// CONCATENATED MODULE: ./components/algolia/clustering-map/ClusteringMap.tsx





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore








/**
 * Este número es la escala que se usa como referencia para calcular
 * el centro de los markers en el mapa cuando se despliega el Info View. Está
 * relacionado con DISPLACEMENT_REFERENCE.
 */ const SCALE_REFERENCE = 116.52824798807345;
/**
 * Este número es el desplacamiento que se usa como referencia para calcular
 * el centro de los markers en el mapa cuando se despliega el Info View. Está
 * relacionado con SCALE_REFERENCE.
 */ const DISPLACEMENT_REFERENCE = 0.2;
/**
 * Calculate the width of 1 map pixel in meters
 * Based on latitude and zoom level
 * @see https://groups.google.com/d/msg/google-maps-js-api-v3/hDRO4oHVSeM/osOYQYXg2oUJ
 * @param latitude
 * @param zoom
 * @returns
 */ const getScale = (latitude, zoom)=>156543.03392 * Math.cos(latitude * Math.PI / 180) / Math.pow(2, zoom);
/**
 * ClusteringMap
 */ const ClusteringMapAlgolia = (param)=>{
    let { className =""  } = param;
    const { results  } = (0,useHits/* useHits */.O)();
    // TODO: Arreglar tipos
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const resultParams = results === null || results === void 0 ? void 0 : results.params;
    const tempUrl = (0,src.parse)((0,src.remove)((0,src.remove)((0,src.remove)(resultParams, "hitsPerPage"), "maxValuesPerFacet"), "page"));
    const params = (0,src.stringify)(tempUrl);
    const [data, setData] = (0,compat_module.useState)(null);
    const [isLoading, setLoading] = (0,compat_module.useState)(false);
    const [error, setError] = (0,compat_module.useState)(null);
    const mapRef = (0,compat_module.useRef)(null);
    const [ref, inView] = (0,react_intersection_observer_modern/* useInView */.YD)({
        /* Optional options */ triggerOnce: false,
        rootMargin: "0px 0px"
    });
    const points = (0,compat_module.useMemo)(()=>data && !error ? data.hits.map((hit)=>hit.latitud && hit.longitud ? {
                type: "Feature",
                properties: {
                    cluster: false,
                    hit,
                    hitId: hit.codigoUnidadAlquiler
                },
                geometry: {
                    type: "Point",
                    coordinates: [
                        parseFloat(hit.longitud),
                        parseFloat(hit.latitud)
                    ]
                }
            } : null).filter(Boolean) : [], [
        data,
        error
    ]);
    const [mapBounds, setMapBounds] = (0,compat_module.useState)(null);
    const [zoom, setZoom] = (0,compat_module.useState)(14);
    const { clusters , supercluster  } = (0,use_supercluster_esm/* default */.Z)({
        points: points,
        bounds: mapBounds,
        zoom,
        options: {
            radius: 70
        }
    });
    (0,compat_module.useEffect)(()=>{
        setLoading(true);
        (0,post/* post */.v)("/api/flats", {
            params: (0,src.remove)(params, "insideBoundingBox")
        }).then((data)=>setData(data)).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        tempUrl.facets,
        tempUrl.facetFilters,
        tempUrl.numericFilters
    ]);
    const LoadingComponent = // TODO: Agregar animación de carga
    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "flex items-center justify-center bg-neutrals-50 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "flex w-max flex-row items-center justify-between gap-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "h-2 w-2 rounded-full bg-neutrals-900"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "h-2 w-2 rounded-full bg-neutrals-900"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "h-1.5 w-1.5 rounded-full bg-neutrals-500"
                })
            ]
        })
    });
    var _NEXT_PUBLIC_MAP_API_KEY;
    return !isLoading && data && !error ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("style", {
                children: "\n        .gmnoprint.gm-bundled-control {\n          right: 52px !important;\n          top: 16px !important;\n        }\n\n        .gmnoprint.gm-bundled-control .gmnoprint div {\n          height: auto !important;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          background: none !important;\n          box-shadow: none !important;\n          gap: 12px;\n        }\n\n        .gmnoprint.gm-bundled-control .gmnoprint div > button + div {\n          display: none;\n        }\n\n        .gmnoprint.gm-bundled-control .gmnoprint div button {\n          border-radius: 50% !important;\n          background: #fff !important;\n          width: 40px !important;\n          height: 40px !important;\n          box-shadow: 0px 4px 12px rgba(13, 31, 35, 0.16);\n          outline: 1px solid #d9ebef; \n        }\n      "
            }),
            mapBounds && inView && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Configure/* Configure */.T, {
                insideBoundingBox: [
                    [
                        mapBounds[1],
                        mapBounds[0],
                        mapBounds[3],
                        mapBounds[2]
                    ]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_modern/* default */.Z, {
                apiKey: (_NEXT_PUBLIC_MAP_API_KEY = "AIzaSyAl4betmIYE1lDlsijqxszDk-5BmibLEOI") !== null && _NEXT_PUBLIC_MAP_API_KEY !== void 0 ? _NEXT_PUBLIC_MAP_API_KEY : "",
                defaultZoom: 10,
                onGoogleApiLoaded: (param)=>{
                    let { map  } = param;
                    mapRef.current = map;
                    const bounds = new google.maps.LatLngBounds();
                    points.forEach((point)=>{
                        if (point === null || point === void 0 ? void 0 : point.geometry) bounds.extend({
                            lng: point.geometry.coordinates[0],
                            lat: point.geometry.coordinates[1]
                        });
                    });
                    map.fitBounds(bounds);
                    const listener = google.maps.event.addListener(map, "bounds_changed", ()=>{
                        const zoom = map.getZoom();
                        if (zoom && zoom > 20) map.setZoom(17);
                        google.maps.event.removeListener(listener);
                    });
                    map.setOptions({
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_TOP
                        }
                    });
                },
                defaultCenter: {
                    lat: 40.2085,
                    lng: -3.713
                },
                onChange: (param)=>{
                    let { bounds , zoom  } = param;
                    const ne = bounds.getNorthEast();
                    const sw = bounds.getSouthWest();
                    setZoom(zoom);
                    setMapBounds([
                        sw.lng(),
                        sw.lat(),
                        ne.lng(),
                        ne.lat()
                    ]);
                },
                options: {
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoom: zoom,
                    disableDefaultUI: false,
                    clickableIcons: false
                },
                containerProps: {
                    className
                },
                loadingContent: LoadingComponent,
                idleContent: LoadingComponent,
                errorContent: LoadingComponent,
                ref: ref,
                children: clusters.map((cluster)=>{
                    const [longitude, latitude] = cluster.geometry.coordinates;
                    const { cluster: isCluster , point_count: pointCount , hit , hitId  } = cluster.properties;
                    return isCluster ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_cluster, {
                        lat: latitude,
                        lng: longitude,
                        count: pointCount,
                        mapRef: mapRef,
                        cluster: cluster,
                        superCluster: supercluster
                    }, "cluster-".concat(cluster.id)) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(marker/* default */.Z, {
                        lat: latitude,
                        lng: longitude,
                        onClick: ()=>{
                            if (mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) {
                                const map = mapRef.current;
                                const zoom = map.getZoom();
                                if (zoom) {
                                    const scale = getScale(latitude, zoom);
                                    const multiplier = scale * DISPLACEMENT_REFERENCE / SCALE_REFERENCE;
                                    (0,helpers/* gtmPush */.De)({
                                        event: "map_interaction",
                                        map_action: "select",
                                        item_id: hit === null || hit === void 0 ? void 0 : hit.codigoUnidadAlquiler,
                                        item_name: hit === null || hit === void 0 ? void 0 : hit.nombreUE,
                                        item_type: (0,utils/* capitalize */.kC)(hit === null || hit === void 0 ? void 0 : hit.ventaAlquiler)
                                    });
                                    map.setCenter({
                                        lat: latitude - multiplier,
                                        lng: longitude + multiplier
                                    });
                                }
                            }
                        },
                        children: (param)=>/*#__PURE__*/ {
                            let { close , isOpen  } = param;
                            return (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "relative ".concat(isOpen ? "" : "mt-6"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(card_flat/* default */.Z, {
                                        ...(0,card/* cardTransformer */.R)(hit, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        ()=>{}),
                                        className: "max-w-xs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                                        className: "absolute left-4 top-2.5 flex h-8 w-8 items-center justify-center rounded-full bg-neutrals-0/60 hover:bg-neutrals-0/80",
                                        onClick: close,
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(x["default"], {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            });
                        }
                    }, hitId);
                })
            })
        ]
    }) : LoadingComponent;
};
ClusteringMapAlgolia.displayName = "ClusteringMapAlgolia";

;// CONCATENATED MODULE: ./components/algolia/clustering-map/index.ts

/* harmony default export */ var clustering_map = (ClusteringMapAlgolia);


/***/ }),

/***/ 39866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_marker; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
;// CONCATENATED MODULE: ./public/assets/images/marker.svg
var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/compat_module.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/compat_module.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#3F9CAE"
  })), _rect2 || (_rect2 = /*#__PURE__*/compat_module.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#fff",
    strokeWidth: 4
  })));
};

/* harmony default export */ var marker = (SvgMarker);
;// CONCATENATED MODULE: ./components/atoms/marker/Marker.tsx



/**
 * Marker
 */ const Marker = (param)=>{
    let { className ="" , children , onClick  } = param;
    const [show, setShow] = (0,compat_module.useState)(false);
    const ref = (0,compat_module.useRef)(null);
    (0,compat_module.useEffect)(()=>{
        const element = ref.current;
        if (show && element) {
            const parent = element.parentElement;
            parent === null || parent === void 0 ? void 0 : parent.style.setProperty("z-index", "10");
        }
        return ()=>{
            if (element) {
                const parent = element.parentElement;
                parent === null || parent === void 0 ? void 0 : parent.style.setProperty("z-index", "0");
            }
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                ref: ref,
                className: "inline-block -translate-x-1/2 -translate-y-1/2 ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(marker, {
                    className: "h-8 w-8 ".concat(children ? "cursor-pointer" : ""),
                    ...children && {
                        onClick: ()=>{
                            setShow((show)=>!show);
                            onClick === null || onClick === void 0 ? void 0 : onClick();
                        }
                    }
                })
            }),
            show ? typeof children === "function" ? children({
                isOpen: show,
                close: ()=>setShow(false)
            }) : children : null
        ]
    });
};
Marker.displayName = "Marker";

;// CONCATENATED MODULE: ./components/atoms/marker/index.ts

/* harmony default export */ var atoms_marker = (Marker);


/***/ }),

/***/ 31101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ client; }
/* harmony export */ });
const client = async function(endpoint) {
    let { body , ...customConfig } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const headers = {
        "Content-Type": "application/json"
    };
    const config = {
        method: body ? "POST" : "GET",
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
            ...customConfig.withCredentials && {
                credentials: "include"
            }
        }
    };
    if (body) {
        config.body = JSON.stringify(body);
    }
    const response = await fetch(endpoint, config);
    if (response.ok) {
        return await response.json();
    } else {
        const errorMessage = await response.json();
        return Promise.reject(errorMessage);
    }
};


/***/ }),

/***/ 45618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ post; }
/* harmony export */ });
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31101);

const post = async (endpoint, body, config)=>(0,_client__WEBPACK_IMPORTED_MODULE_0__/* .client */ .L)(endpoint, {
        body,
        ...config
    });


/***/ })

}]);